import { createAuthClient } from 'better-auth/react'

import { API_URL, VERSION_OVERRIDE } from './api'

export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: '/api/auth',
  fetchOptions: {
    credentials: 'include',
    headers: VERSION_OVERRIDE
      ? { 'Cloudflare-Workers-Version-Overrides': `ohear-api="${VERSION_OVERRIDE}"` }
      : undefined,
  },
})
